import React from 'react'

const Button = props => (
  <a
    className={
      (props.className ? props.className : '') +
      ' btn ' +
      (props.second ? 'second' : '')
    }
    href={'#' + props.link}
    onClick={() => {
      Helpers.SmoothScroll.scrollTo(props.link)
    }}
  >
    {props.children}
  </a>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/button.js